import { getCookie } from 'cookies-next';

export type CookieConsentCategories =
  | 'consent'
  | 'necessary'
  | 'functional'
  | 'analytics'
  | 'performance'
  | 'advertisement'
  | 'other';

const cookieYesStringAsObject = (cookie: string): Record<CookieConsentCategories, string> => {
  return cookie.split(',').reduce(
    (obj, pair) => {
      const [key, value] = pair.split(':');
      obj[key as CookieConsentCategories] = value;

      return obj;
    },
    {} as Record<CookieConsentCategories, string>,
  );
};

export const getCookieConsentForCategory = (category: CookieConsentCategories): boolean => {
  const cookie = getCookie('cookieyes-consent');

  // If the cookie doesn't exist, this means we have not set up cookie yes on the domain.
  // In this case, we should assume that we do not need to ask for consent.
  // In the case of Geo Targeting, for regions that we do not target, Cookie Yes assumes that consent is given anyway.
  // This is a safe default to ensure that we do not break the site for users in regions we do not target.
  if (!cookie) {
    return true;
  }

  const cookieObject = cookieYesStringAsObject(cookie);

  return cookieObject['consent'] === 'yes' && cookieObject[category] === 'yes';
};
